import React, { ReactNode, useCallback, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { ReducerState } from "Redux/store";
import * as Styled from "./styles";
import Search from "Components/Form/Inputs/Search";
import { FiltersContext, useFilters } from "Contexts/FiltersContext";

interface Props {
  children?: ReactNode;
  searchHidden?: boolean;
  total?: number;
  setSearch?: React.Dispatch<React.SetStateAction<string>>;
  displayOn?: boolean;
  setDisplayOn?: React.Dispatch<React.SetStateAction<boolean>>;
  onclick?: () => void;
}

const Filters: React.FC<Props> = ({
  children = "",
  searchHidden = true,
  total = 0,
  setSearch,
  onclick,
  displayOn,
  setDisplayOn,
}) => {
  const { mobile } = useSelector((state: ReducerState) => state.locale);
  const [expand, setExpand] = useState(false);
  const [value, setValue] = useState("");
  const [hide, setHide] = useState(true);
  const isMobileMenuOpen = displayOn && mobile;
  const { registerResetFn } = useFilters();
  const resetFunctionsRef = useRef<(() => void)[]>([]);

  const fetchList = useCallback(() => {
    if (setSearch) {
      setSearch(value);
    }
  }, [setSearch, value]);

  const registerResetFunction = (resetFunction: () => void) => {
    resetFunctionsRef.current.push(resetFunction);
  };

  const clearSearch = () => {
    setValue("");
    setSearch && setSearch("teste");
    fetchList();
  };

  const clearFilters = () => {
    resetFunctionsRef.current.forEach(resetFunction => resetFunction());
  };

  const handleClearFilters = () => {
    clearSearch();
    clearFilters();
  };

  return (
    <FiltersContext.Provider value={{ registerResetFn: registerResetFunction }}>
      <>
        {isMobileMenuOpen && (
          <Styled.Backdrop
            onClick={() => setDisplayOn && setDisplayOn(!displayOn)}
          />
        )}
        <Styled.PageContainer id="filters2" displayOn={displayOn}>
          {mobile && (
            <Styled.Container style={{ marginTop: 0 }}>
              {/* sdfsadr     */}
              <Styled.MenuCloseContainer>
                <Styled.MenuClose
                  id="mobile-menu-close"
                  onClick={() => setDisplayOn && setDisplayOn(!displayOn)}
                />
                <Styled.FilterCleaner onClick={handleClearFilters}>
                  Limpar Filtros
                </Styled.FilterCleaner>
              </Styled.MenuCloseContainer>
            </Styled.Container>
          )}

          <Styled.Container style={mobile ? {} : { marginTop: 20 }}>
            {!searchHidden && (
              <Styled.SearchContainer>
                <Styled.SearchTitleContainer>
                  <Styled.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={searchHidden}
                    className="filters-title"
                    onClick={() => setExpand(!expand)}
                  >
                    Pesquisar
                  </Styled.Title>
                  {/* {mobile && (
                    <Styled.Expand onClick={() => setHide(!hide)}>
                      {hide ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )} */}
                </Styled.SearchTitleContainer>
                <Search
                  setValue={setValue}
                  placeholder="Pesquisar..."
                  defaultValue={value}
                  shadow={false}
                  submit={() => fetchList()}
                  newSearch={true}
                  // hide={hide}
                  displayOn={displayOn}
                  setDisplayOn={setDisplayOn}
                />
              </Styled.SearchContainer>
            )}
          </Styled.Container>
          {children}
        </Styled.PageContainer>
      </>
    </FiltersContext.Provider>
  );
};
export default Filters;
